import axios from 'axios';
import { createAsyncThunk, isFulfilled, isPending } from '@reduxjs/toolkit';
import { cleanEntity } from '../shared/util/entity-utils/entity-utils';
import { createEntitySlice, EntityState, getAllRequest, serializeAxiosError } from '../shared/reducers/reducer.utils';

const apiUrl = 'api/profase-periodo-actividad-instancias';

const initialState: EntityState<any> = {
    loading: false,
    errorMessage: null,
    entities: [],
    entity: {},
    updating: false,
    totalItems: 0,
    updateSuccess: false,
};

export const getEntities = createAsyncThunk(
    'profasePeriodoActividadInstancia/fetch_entity_list',
    async (request: any) => {
        const params = getAllRequest(request);
        const requestUrl = `${apiUrl}?${params}&cacheBuster=${new Date().getTime()}`;
        return axios.get<any[]>(requestUrl);
    },
    { serializeError: serializeAxiosError },
);

export const getEntity = createAsyncThunk(
    'profasePeriodoActividadInstancia/fetch_entity',
    async (id: string | number) => {
        return axios.get<any>(`${apiUrl}/${id}`);
    },
    { serializeError: serializeAxiosError },
);

export const createEntity = createAsyncThunk(
    'profasePeriodoActividadInstancia/create_entity',
    async (entity: any) => {
        return axios.post<any>(apiUrl, cleanEntity(entity));
    },
    { serializeError: serializeAxiosError },
);

export const updateEntity = createAsyncThunk(
    'profasePeriodoActividadInstancia/update_entity',
    async (entity: any) => {
        return axios.put<any>(`${apiUrl}/${entity.id}`, cleanEntity(entity));
    },
    { serializeError: serializeAxiosError },
);

export const deleteEntity = createAsyncThunk(
    'profasePeriodoActividadInstancia/delete_entity',
    async (id: string | number) => {
        return axios.delete<any>(`${apiUrl}/${id}`);
    },
    { serializeError: serializeAxiosError },
);

export const archivarInstancia = createAsyncThunk(
    'profasePeriodoActividadInstancia/archivar',
    async (id: number) => axios.post<any>(`${apiUrl}/${id}/archivar`),
    { serializeError: serializeAxiosError },
);

export const revertirArchivadoInstancia = createAsyncThunk(
    'profasePeriodoActividadInstancia/revertir_archivado',
    async (id: number) => axios.post<any>(`${apiUrl}/${id}/revertir-archivado`),
    { serializeError: serializeAxiosError },
);

export const generarProcesosInstancia = createAsyncThunk(
    'profasePeriodoActividadInstancia/generar_procesos',
    async (id: number) => axios.post<any>(`${apiUrl}/${id}/generar-procesos`),
    { serializeError: serializeAxiosError },
);

export const anularProcesosInstancia = createAsyncThunk(
    'profasePeriodoActividadInstancia/anular_procesos',
    async (id: number) => axios.post<any>(`${apiUrl}/${id}/anular`),
    { serializeError: serializeAxiosError },
);

export const ProfasePeriodoActividadInstanciaSlice = createEntitySlice({
    name: 'profasePeriodoActividadInstancia',
    initialState,
    extraReducers(builder) {
        builder
            .addCase(getEntity.fulfilled, (state, action) => {
                state.loading = false;
                state.entity = action.payload.data;
            })
            .addCase(deleteEntity.fulfilled, state => {
                state.updating = false;
                state.updateSuccess = true;
                state.entity = {};
            })
            .addMatcher(isFulfilled(getEntities), (state, action) => {
                const { data, headers } = action.payload;
                return {
                    ...state,
                    loading: false,
                    entities: data,
                    totalItems: parseInt(headers['x-total-count'], 10),
                };
            })
            .addMatcher(isFulfilled(createEntity, updateEntity, archivarInstancia, revertirArchivadoInstancia, generarProcesosInstancia, anularProcesosInstancia), (state, action) => {
                state.updating = false;
                state.loading = false;
                state.updateSuccess = true;
                state.entity = action.payload.data;
            })
            .addMatcher(isPending(getEntities, getEntity), state => {
                state.errorMessage = null;
                state.updateSuccess = false;
                state.loading = true;
            })
            .addMatcher(isPending(createEntity, updateEntity, deleteEntity, archivarInstancia, revertirArchivadoInstancia, generarProcesosInstancia, anularProcesosInstancia), state => {
                state.errorMessage = null;
                state.updateSuccess = false;
                state.updating = true;
            });
    },
});

export const { reset } = ProfasePeriodoActividadInstanciaSlice.actions;
export default ProfasePeriodoActividadInstanciaSlice.reducer;
